import { DtoBase } from "../DtoBase";
import { List } from "../../DiscoveryEngine.TS/Utils/List";
import { ObjSerUtils } from "../../DiscoveryEngine.TS/Serialization/ObjSerUtils";


export class NetworkAgentInfo extends DtoBase {

	public AgentGuid: string;
	public AgentName: string;
	public ClientAgentApiKey: string;
	public ClientAgentApiKeyName: string;
	public ClientAgentApiKeyUsername: string;
	public ClientAgentApiKeyUserGuid: string;

	constructor() {
		super();

		this.AgentGuid = "";
		this.AgentName = "";
		this.ClientAgentApiKey = "";
		this.ClientAgentApiKeyName = "";
		this.ClientAgentApiKeyUsername = "";
		this.ClientAgentApiKeyUserGuid = "";
	}

	public get HasAgentGuid(): boolean {
		return !!this.AgentGuid;
	}

	public get HasAgentName(): boolean {
		return !!this.AgentName;
	}

	public get HasClientAgentApiKey(): boolean {
		return !!this.ClientAgentApiKey;
	}

	public get HasClientAgentApiKeyName(): boolean {
		return !!this.ClientAgentApiKeyName;
	}

	public get HasClientAgentApiKeyUsername(): boolean {
		return !!this.ClientAgentApiKeyUsername;
	}

	public get HasClientAgentApiKeyUserGuid(): boolean {
		return !!this.ClientAgentApiKeyUserGuid;
	}

	public Write(obj: any, context: any): void {
		obj.network_agent_info = {};
		obj = obj.network_agent_info;

		super.Write(obj, context);

		if (this.HasAgentGuid) {
			obj.agent_guid = this.AgentGuid;
		}

		if (this.HasAgentName) {
			obj.agent_name = this.AgentName;
		}

		if (this.HasClientAgentApiKey) {
			obj.client_agent_api_key = this.ClientAgentApiKey;
		}

		if (this.HasClientAgentApiKeyName) {
			obj.client_agent_api_key_name = this.ClientAgentApiKeyName;
		}

		if (this.HasClientAgentApiKeyUsername) {
			obj.client_agent_api_key_user_name = this.ClientAgentApiKeyUsername;
		}

		if (this.HasClientAgentApiKeyUserGuid) {
			obj.client_agent_api_key_user_guid = this.ClientAgentApiKeyUserGuid;
		}
	}

	public Read(obj: any, context: any): void {
		if (!obj.network_agent_info)
			throw new Error();
		obj = obj.network_agent_info;

		super.Read(obj, context);

		if (obj.agent_guid !== undefined) {
			this.AgentGuid = obj.agent_guid;
		}

		if (obj.agent_name !== undefined) {
			this.AgentName = obj.agent_name;
		}

		if (obj.client_agent_api_key !== undefined) {
			this.ClientAgentApiKey = obj.client_agent_api_key;
		}

		if (obj.client_agent_api_key_name !== undefined) {
			this.ClientAgentApiKeyName = obj.client_agent_api_key_name;
		}

		if (obj.client_agent_api_key_user_name !== undefined) {
			this.ClientAgentApiKeyUsername = obj.client_agent_api_key_user_name;
		}

		if (obj.client_agent_api_key_user_guid !== undefined) {
			this.ClientAgentApiKeyUserGuid = obj.client_agent_api_key_user_guid;
		}
	}
}


export class PrepareNetworkTransferResultDto extends DtoBase {

	public NetworkAgents: List<NetworkAgentInfo>;

	constructor() {
		super();

		this.Clear();
	}

	public Clear(): void {
		this.NetworkAgents = new List<NetworkAgentInfo>();
	}

	public get HasNetworkAgents(): boolean {
		return (!!this.NetworkAgents && this.NetworkAgents.Count > 0);
	}

	public Write(obj: any, context: any): void {
		obj.prepare_network_transfer_result = {};
		obj = obj.prepare_network_transfer_result;

		super.Write(obj, context);

		if (this.HasNetworkAgents) {
			obj.network_agents = [];
			ObjSerUtils.WriteObjSerCollection(obj.network_agents, this.NetworkAgents, context);
		}
	}

	public Read(obj: any, context: any): void {
		if (!obj.prepare_network_transfer_result)
			throw new Error();
		obj = obj.prepare_network_transfer_result;

		super.Read(obj, context);

		if (obj.network_agents !== undefined) {
			this.NetworkAgents.Clear();
			ObjSerUtils.ReadObjSerCollection(obj.network_agents, this.NetworkAgents,
				(value: any) => new NetworkAgentInfo(), context);
		}
	}

}
